import createFetcher from './createFetcher'
import get from 'lodash/get'
import axios from 'axios'
import isNull from 'lodash/isNull'
import Confirm from 'buddy-glud-component/lib/Confirm'
import moment from 'moment'
import { localStorage, history, cookieStorage } from '../utils'

const host = process.env.REACT_APP_HOST || ''
const token_host = process.env.REACT_APP_SIT_HOST || ''
const token_endpoint = process.env.REACT_APP_TOKEN_ENDPOINT || ''
const key = process.env.REACT_APP_KEY || ''
const secret = process.env.REACT_APP_PRIKEY || ''
const scbSandbox = process.env.REACT_APP_QR_SANDBOX
const qrCodeOwnerID = process.env.REACT_APP_QR_OWNERID
const qrCodeKey = process.env.REACT_APP_QR_KEY
const qrType = process.env.REACT_APP_QR_TYPE
const qrPPType = process.env.REACT_APP_QR_PP_TYPE
const qrPPId = process.env.REACT_APP_PPID
const qrPrefix = process.env.REACT_APP_QR_PREFIX
const useMock = true


const fetchPOST = async ({
  useMock= false,
  url= '',
  data= {},
  jsonMock= '',
  delay= 0,
  notHeader= false,
  headers= {}
}) => {
  let authen = ''
  await axios.post(`${token_host}${token_endpoint}/authen/generateToken`, {
      key,
      secret
  }).then(res => {
    authen = res?.data?.result?.token
  })

  let version = ''
  let currentVersion = isNull(localStorage.get('salesplus-version')) ? '0.0.0' : localStorage.get('salesplus-version')
  await axios.get(`${window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '')}/meta.json?ref=${moment().format('YYYYMMDDHHmmss')}`).then(res => {
    version = get(res, 'data.version', '0.0.0')

    if(version !== currentVersion) {
      Confirm.open({
        title: 'เวอร์ชั่นอัพเดท',
        content: `ระบบมีการอัพเดทเวอร์ชั่นเป็น SalesPlus-V-${version} กด ตกลง เพื่ออัพเดทเวอร์ชั่น`,
        closeButton: false,
        closeOnClickOutside: false,
        buttons: [
          {
            primary: true,
            label: 'ตกลง',
            onClick: () => {
              localStorage.set({
                key: 'salesplus-version',
                value: version
              })

              cookieStorage.set({ cname: 'xxopoc', cvalue: '', exdays: -1 })
              cookieStorage.set({ cname: 'SPACTIVECODE', cvalue: '', exdays: -1 })
              cookieStorage.set({ cname: 'salesPlusSaleInfo', cvalue: '', exdays: -1 })
              localStorage.remove('salesPlusMenu')

              history.push('/')
              window.location.reload('/')
            }
          }
        ]
      })
    }
  })

  if(version === currentVersion){
    return (
      createFetcher({
        useMock,
        method: 'post',
        url,
        headers: { ...headers, 'Authorization': `Bearer ${authen}` },
        data,
        jsonMock,
        delay
      })
    )
  }
}

const fetchGET = async ({
  useMock= false,
  url= '',
  params= {},
  jsonMock= '',
  delay= 0,
  headers= {}
}) => {
  let authen = ''
  await axios.post(`${token_host}${token_endpoint}/authen/generateToken`, {
      key,
      secret
  }).then(res => {
    authen = res?.data?.result?.token
  })

  let version = ''
  let currentVersion = isNull(localStorage.get('salesplus-version')) ? '0.0.0' : localStorage.get('salesplus-version')
  await axios.get(`${window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '')}/meta.json?ref=${moment().format('YYYYMMDDHHmmss')}`).then(res => {
    version = get(res, 'data.version', '0.0.0')

    if(version !== currentVersion) {
      Confirm.open({
        title: 'เวอร์ชั่นอัพเดท',
        content: `ระบบมีการอัพเดทเวอร์ชั่นเป็น SalesPlus-V-${version} กด ตกลง เพื่ออัพเดทเวอร์ชั่น`,
        closeButton: false,
        closeOnClickOutside: false,
        buttons: [
          {
            primary: true,
            label: 'ตกลง',
            onClick: () => {
              localStorage.set({
                key: 'salesplus-version',
                value: version
              })

              cookieStorage.set({ cname: 'xxopoc', cvalue: '', exdays: -1 })
              cookieStorage.set({ cname: 'SPACTIVECODE', cvalue: '', exdays: -1 })
              cookieStorage.set({ cname: 'salesPlusSaleInfo', cvalue: '', exdays: -1 })
              localStorage.remove('salesPlusMenu')

              history.push('/')
              window.location.reload('/')
            }
          }
        ]
      })
    }
  })

  if(version === currentVersion){
    return (
      createFetcher({
        useMock,
        method: 'get',
        url,
        headers: { ...headers, 'Authorization': `Bearer ${authen}` },
        params,
        jsonMock,
        delay
      })
    )
  }
}

const fetchQRCodeAccessToken = (data) => {
  return (
    createFetcher({
      useMock: false,
      method: 'post',
      url:  `${scbSandbox}/v1/oauth/token`,
      headers: {
        'Content-Type': 'application/json',
        'resourceOwnerId': qrCodeOwnerID,
        'requestUId': get(data, 'uId', ''),
        'accept-language': 'EN'
      },
      data: {
        applicationKey: qrCodeOwnerID,
        applicationSecret: qrCodeKey,
        authCode: ''
      },
      jsonMock: ``,
      delay: 0
    })
  )
}

const fetchQRCodeImage = (accessToken, data) => {
  return (
    createFetcher({
      useMock: false,
      method: 'post',
      url:  `${scbSandbox}/v1/payment/qrcode/create`,
      headers: {
        'Content-Type': 'application/json',
        'authorization': `Bearer ${accessToken}`,
        'resourceOwnerId': qrCodeOwnerID,
        'requestUId': get(data, 'ref1', ''),
        'accept-language': 'EN'
      },
      data: {
        qrType: qrType,
        ppType: qrPPType,
        ppId: qrPPId,
        ...data,
        ref3: qrPrefix
      },
      jsonMock: ``,
      delay: 0
    })
  )
}

const fetchTripList = (data) => {
  return (
    createFetcher({
      useMock,
      method: 'post',
      url:  `${host}/api/get/triplist`,
      headers: {},
      data,
      jsonMock: `Trip.json`,
      delay: 0
    })
  )
}

const fetchPartnerList = (data) => {
  return (
    createFetcher({
      useMock,
      method: 'post',
      url:  `${host}/api/get/partnerList`,
      headers: {},
      data,
      jsonMock: `Partner.json`,
      delay: 0
    })
  )
}

const fetchRemainOrder = (data) => {
  return (
    createFetcher({
      useMock,
      method: 'post',
      url:  `${host}/api/get/remainOrderList`,
      headers: {},
      data,
      jsonMock: `RemainOrder.json`,
      delay: 0
    })
  )
}

const fetchProvince = (data) => {
  const temp = {
    // useMock,
    useMock: false,
    method: 'get',
    // url:  `${host}/api/get/triplist`,
    url:  `https://dev-spcrp.sahapat.com/api/address/getProvince`,
    headers: { 'API-KEY': '123_land-shark_456_stuffed-lizard' },
    params: data,
    jsonMock: `Province.json`,
    delay: 0
  }
  console.log('temp',temp);
  return (    
    createFetcher(temp)
  )
}

const fetchCheckTripStatus = (data) => {
  return (
    createFetcher({
      useMock,
      method: 'post',
      // url:  `${host}/sop/vansales/checktripstatus`,
      url:  `https://prodapi.sahapat.com/sop/vansales/checktripstatus`,
      headers: { 'API-KEY': '123_land-shark_456_stuffed-lizard' },
      data,
      delay: 0
    })
  )
}


export {
  fetchPOST,
  fetchGET,
  fetchTripList,
  fetchPartnerList,
  fetchRemainOrder,
  fetchQRCodeAccessToken,
  fetchQRCodeImage,
  fetchProvince,
  fetchCheckTripStatus
}
